// extracted by mini-css-extract-plugin
export var container = "service-title-module--container--9fwdG";
export var subTitle = "service-title-module--subTitle--5xvMU";
export var title = "service-title-module--title--G6LNC";
export var contentContainer = "service-title-module--contentContainer--5wNII";
export var content1 = "service-title-module--content1--RLU0-";
export var and = "service-title-module--and--OwTo7";
export var content2 = "service-title-module--content2--IYA-+";
export var colorBlue = "service-title-module--colorBlue--e6eKV";